import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from "./AuthProvider";
import LoadingComponent from "../components/LoadingComponent"

function ProtectedRoute({ children }) {
  const { isLoggedIn, recId, requiresPasswordSetup } = useAuth();
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // Add a small delay to ensure auth state is properly loaded
    const timer = setTimeout(() => {
      setIsChecking(false);
      console.log('ProtectedRoute: Auth check complete', { isLoggedIn, recId, requiresPasswordSetup });
    }, 500);

    return () => clearTimeout(timer);
  }, [isLoggedIn, recId, requiresPasswordSetup]);

  // Show loading state while checking authentication
  if (isChecking) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <LoadingComponent/>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isLoggedIn) {
    console.log('ProtectedRoute: Not logged in, redirecting to login');
    return <Navigate to="/sign/in" replace />;
  }

  // Redirect to set password if required (but not if already on set-password page)
  if (requiresPasswordSetup && location.pathname !== '/set-password') {
    console.log('ProtectedRoute: Password setup required, redirecting to set-password');
    return <Navigate to="/set-password" replace />;
  }

  // User is authenticated, render the protected content
  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;
